import React, { useState, useEffect } from "react";

import { endPoints } from "../../../constant/Environment";
import { getAllFilterData } from "../../../Utility/API";
import {
  Box,
  Button,
  TextField,
  MenuItem,
  IconButton,
  TablePagination,
  Dialog,
  Typography,
} from "@mui/material";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import moment from "moment-timezone";
import { useTheme } from "@mui/material/styles";

import Toaster from "../../../components/Toast";
import Loader from "../../../components/Loader";
import { tokens } from "../../../theme";
import { mono, pill, statusKind, th, td, unsettledRowBg, filterFieldSx } from "./uiKit";
import CashDetails from "./cashDetails";

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton onClick={handleBackButtonClick} disabled={page === 0} aria-label="previous page">
        {theme.direction === "rtl" ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
    </Box>
  );
}

const WithdrawalStatusList = [
  { id: "1", name: "Approved" },
  { id: "0", name: "Pending" },
  { id: "2", name: "Hold" },
  { id: "3", name: "Cancelled" },
];

const toCurrency = (value, fallback = "0.00") => {
  if (value === null || value === undefined || value === "") return fallback;

  const numericValue = Number(String(value).replace(/[^0-9.-]/g, ""));
  return Number.isFinite(numericValue) ? numericValue.toFixed(2) : fallback;
};

const CashWithDrawal = () => {
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [page, setPage] = React.useState(1);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [totalcount, setTotalCount] = useState(1);

  const [userId, setUserId] = useState("");
  const [Transtype, setTransType] = useState("");
  const [username, setuserName] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");

  const [detailsModal, setDetailModal] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState({});

  useEffect(() => {
    paymentsData(1, filteredData);
  }, []);

  // withdrawl payments get api call
  const paymentsData = async (page, data) => {
    let url = `${endPoints.api.WITHDRAW_TRANSACTIONS}/${page}/${rowsPerPage}`;
    setIsLoading(true);
    await getAllFilterData(url, data)
      .then((response) => {
        setIsLoading(false);
        if (response?.status === "success") {
          let data = response.data;
          setRows(response.data);
          setTotalCount(data[0]?.totalcount);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
      });
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage + 1);
    paymentsData(newPage + 1, filteredData);
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
  };

  useEffect(() => {
    paymentsData(page, filteredData);
  }, [rowsPerPage]);

  let filteredData = {
    userId: userId,
    status: Transtype,
    name: name,
    userName: username,
    email: email,
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      paymentsData(1, filteredData);
    }
  };

  return (
    <Box>
      <Toaster></Toaster>
      {isLoading && <Loader spinner={true} visible={isLoading} />}

      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1.5, alignItems: "center", mb: 2 }}>
        <TextField
          size="small"
          label="Customer ID"
          placeholder="Enter Customer ID"
          value={userId}
          onChange={(e) => setUserId(e.target.value)}
          onKeyDown={handleKeyDown}
          sx={filterFieldSx}
        />
        <TextField
          size="small"
          label="Name"
          placeholder="First or Last Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          onKeyDown={handleKeyDown}
          sx={filterFieldSx}
        />
        <TextField
          size="small"
          label="Username"
          placeholder="Enter Username"
          value={username}
          onChange={(e) => setuserName(e.target.value)}
          onKeyDown={handleKeyDown}
          sx={filterFieldSx}
        />
        <TextField
          size="small"
          label="Email"
          placeholder="Enter Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          onKeyDown={handleKeyDown}
          sx={filterFieldSx}
        />
        <TextField
          select
          size="small"
          label="Withdrawal Status"
          value={Transtype}
          onChange={(e) => setTransType(e.target.value)}
          sx={filterFieldSx}
        >
          <MenuItem value="">All statuses</MenuItem>
          {WithdrawalStatusList.map((item) => (
            <MenuItem key={item.id} value={item.id}>
              {item.name}
            </MenuItem>
          ))}
        </TextField>
        <Button variant="contained" size="small" onClick={() => paymentsData(1, filteredData)} sx={{ textTransform: "none" }}>
          Search
        </Button>
      </Box>

      <Box sx={{ overflowX: "auto" }}>
        <Box component="table" sx={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr>
              <th style={th}>Player</th>
              <th style={th}>VIP</th>
              <th style={th}>Trans Date</th>
              <th style={th}>Deposit</th>
              <th style={th}>Settled</th>
              <th style={th}>Withdrawal</th>
              <th style={th}>Redeem</th>
              <th style={th}>Pending #</th>
              <th style={th}>Amount</th>
              <th style={th}>Status</th>
              <th style={th}>Account</th>
              <th style={th}></th>
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 && !isLoading && (
              <tr>
                <td colSpan={12} style={{ ...td, textAlign: "center", color: tokens.textDim }}>
                  No cash withdrawals found
                </td>
              </tr>
            )}
            {rows.map((row) => {
              const unsettled = Number(row.totalDeposit ?? 0) !== Number(row.totalSetlledDeposit ?? 0);
              return (
                <tr key={row.id} style={{ background: unsettled ? unsettledRowBg : "transparent" }}>
                  <td style={td}>
                    <div style={{ fontWeight: 600 }}>
                      {row.name} {row.surname}
                    </div>
                    <div style={{ fontFamily: mono, fontSize: 10.5, color: tokens.textDim2 }}>
                      #{row.id_user} · {row.login}
                    </div>
                  </td>
                  <td style={td}>{row.vipLavel ? pill(row.vipLavel, "neutral") : ""}</td>
                  <td style={{ ...td, fontFamily: mono, color: tokens.textDim }}>
                    {moment.utc(row.insertion_time).format("YYYY-MM-DD")}
                  </td>
                  <td style={{ ...td, fontFamily: mono }}>
                    ${toCurrency(row.totalDeposit)} {unsettled && pill("unsettled", "bad")}
                  </td>
                  <td style={{ ...td, fontFamily: mono }}>${toCurrency(row.totalSetlledDeposit)}</td>
                  <td style={{ ...td, fontFamily: mono }}>${toCurrency(row.totalWidhdrawl)}</td>
                  <td style={{ ...td, fontFamily: mono }}>${toCurrency(row?.totalRedeem)}</td>
                  <td style={{ ...td, fontFamily: mono }}>{toCurrency(row.totalWidhdrawlPending)}</td>
                  <td style={{ ...td, fontFamily: mono, fontWeight: 700 }}>${toCurrency(row.tamount)}</td>
                  <td style={td}>
                    {row.transaction_status ? pill(row.transaction_status, statusKind(row.transaction_status)) : ""}
                  </td>
                  <td style={td}>{row.accountSatus ? pill(row.accountSatus, statusKind(row.accountSatus)) : ""}</td>
                  <td style={td}>
                    <Button
                      size="small"
                      variant="outlined"
                      sx={{ textTransform: "none", color: tokens.secondary, borderColor: "rgba(35,214,160,0.4)" }}
                      onClick={() => {
                        setDetailModal(true);
                        setSelectedRecord(row);
                      }}
                    >
                      More Redeem
                    </Button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Box>
      </Box>

      <TablePagination
        component="div"
        className="hide-rows-per-page-options"
        rowsPerPageOptions={[5, 10, 25, 50]}
        count={rowsPerPage === -1 ? rows.length : totalcount || 0}
        rowsPerPage={rowsPerPage}
        page={page - 1}
        SelectProps={{
          inputProps: { "aria-label": "rows per page" },
          native: true,
        }}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        ActionsComponent={TablePaginationActions}
        sx={{ borderTop: `1px solid ${tokens.border}`, mt: 1 }}
      />

      <Dialog
        fullScreen
        open={detailsModal}
        onClose={() => setDetailModal(false)}
        PaperProps={{ sx: { background: tokens.bg } }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            px: 3,
            py: 1.5,
            borderBottom: `1px solid ${tokens.border}`,
            position: "sticky",
            top: 0,
            zIndex: 2,
            background: tokens.bg,
          }}
        >
          <Typography variant="h6">Redemption Claims Details</Typography>
          <IconButton onClick={() => setDetailModal(false)} aria-label="close">
            <CloseRoundedIcon />
          </IconButton>
        </Box>
        <Box sx={{ p: 3 }}>
          <CashDetails selectedRecord={selectedRecord} />
        </Box>
      </Dialog>
    </Box>
  );
};

export default CashWithDrawal;
